import React from 'react';
import styled from '@emotion/styled';

const Line = styled.div`
  margin: 0;
  font-size: ${p => (p.$compact ? '0.95rem' : '1.1rem')};
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
  text-align: ${p => (p.$compact ? 'left' : 'center')};
  padding: ${p => (p.$compact ? '0' : '12px 32px 16px')};
`;

const Tag = styled.span`
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(156, 39, 176, 0.8);
  background: rgba(156, 39, 176, 0.12);
  border: 1px solid rgba(156, 39, 176, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 8px;
  vertical-align: middle;
`;

/**
 * Shared vipupiste context line (matches Solutions SolutionListView pattern).
 */
export default function PivotContextLine({ title, label = 'Vipupiste', compact = false }) {
  if (!title) return null;
  return (
    <Line $compact={compact}>
      <Tag>{label}</Tag>
      {title}
    </Line>
  );
}
